let basket_ajax = ( function( $ ) {

	let $cart;

	let _init = function() {
		$cart = $( '#cart' );

		if ( $cart.length > 0 ) {
			_setup_remove_item_buttons();
		}

		$( document ).on( 'basket_item_removed', maybe_update_cart_html );
		$( document ).on( 'basket_item_remove_error', _error_removing_item_response );
		$( document ).on( 'basket_item_added', maybe_update_cart_html );
		$( document ).on( 'basket_item_add_error', _error_adding_item_response );
	};

	let _setup_remove_item_buttons = function() {
		let $remove = $( 'a.remove-item, button.remove-item' );

		$remove.on( 'click', function( e ) {
			e.preventDefault();

			let item_id = $( this ).data( 'item-id' );

			if ( item_id ) {
				remove_item( item_id );
			}
		} );
	};

	let add_item = function( ticket_id, user_details, price, tier, coupon ) {
		let data = {
			action: 'basket_add_item',
			basket_remove_item_nonce: ScriptData.crate_basket_add_item_nonce,
			ticket_id: ticket_id,
			user_details: user_details,
			price: price,
			tier: tier,
			coupon: coupon
		};

		$.post( ScriptData.ajaxurl, data, _add_response );
	};

	let _add_response = function( response ) {
		if ( response.success ) {
			$( document ).trigger( 'basket_item_added', response );
		} else {
			$( document ).trigger( 'basket_item_add_error', response );
		}
	};

	let remove_item = function( item_id ) {
		let data = {
			action: 'basket_remove_item',
			basket_remove_item_nonce: ScriptData.crate_basket_remove_item_nonce,
			item_id: item_id,
		};

		$.post( ScriptData.ajaxurl, data, _remove_response );
	};

	let _error_adding_item_response = function() {
		// TODO Implement error notice
	};

	let _remove_response = function( response ) {
		if ( response.success ) {
			$( document ).trigger( 'basket_item_removed', response );
		} else {
			$( document ).trigger( 'basket_item_remove_error', response );
		}
	};

	let _error_removing_item_response = function() {
		// TODO Implement error notice
	};

	let maybe_update_cart_html = function() {
		if ( $cart.length > 0 ) {
			update_cart();
		}
	};

	let update_cart = function() {
		cart_block( 'block' );

		let data = {
			action: 'basket_update',
			basket_update_nonce: ScriptData.crate_basket_update_nonce,
		};

		$.post( ScriptData.ajaxurl, data, _update_cart_response );
	};

	let _update_cart_response = function( response ) {
		if ( response.success ) {
			_update_cart_html( response.menu_items_html, response.cart_count_html, response.cart_count );
		} else {
			cart_block( 'unblock' );
		}
	};

	let _update_cart_html = function( items_html, count_html, count ) {
		$cart.find( '.cart-dropdown .cart-items' ).html( items_html );
		$cart.find( '.ticket-count' ).html( count_html );

		if ( count === 0 ) {
			$cart.find( 'a#toggle-cart' ).addClass( 'disabled' ).removeClass( 'open' ).text( 'Open' );
			$cart.find( '.cart-dropdown' ).slideUp();
		}

		_setup_remove_item_buttons();

		setTimeout( function() {
			cart_block( 'unblock' );
		}, 300 );
	};

	let cart_block = function( how ) {
		if ( how === 'block' ) {
			$cart.find( '.cart-items' ).loading();
			$cart.find( '.ticket-count' ).loading();
		} else if ( how === 'unblock' ) {
			$cart.find( '.cart-items' ).loaded();
			$cart.find( '.ticket-count' ).loaded();
		}
	};

	$( document ).ready( _init );

	return {
		add_item : add_item,
		remove_item : remove_item,
		maybe_update_cart_html : maybe_update_cart_html,
		cart_block : cart_block
	};

} )( jQuery );

module.exports = basket_ajax;